/**
 * Gates the partner scheduled-export history page (RFC 080). Set true in every
 * non-production block of `config/environment.js` and absent from `production`,
 * so the route guard and the reports-index link both go dark in prod.
 */
export const SCHEDULED_EXPORTS_FEATURE_FLAG = 'reportingScheduledExports';
